export const LOCALITY_TYPES = [
  {
    key: "metro",
    label: "Metro",
    description: "5M+ population (Delhi, Mumbai, Bangalore, Hyderabad)",
    color: "red",
  },
  {
    key: "urban",
    label: "Urban",
    description: "1M–5M population (Tier-1/2 cities)",
    color: "blue",
  },
  {
    key: "suburban",
    label: "Suburban",
    description: "100K–1M population (Satellite towns)",
    color: "purple",
  },
  {
    key: "rural",
    label: "Rural",
    description: "<100K population (Small towns, villages)",
    color: "green",
  },
];

export const PRICING_MODELS = {
  BASE_MULTIPLIER: "baseMultiplier",
  DIRECT_VALUES: "directValues",
  HYBRID: "hybrid",
};

export const DEMAND_TIER_MULTIPLIERS = {
  HIGH: 1.5,
  STANDARD: 1.0,
  LOW: 0.6,
};

export const PRICING_FORMULA = "Final Price = Base Price × Demand Tier Multiplier (High: 1.5×, Standard: 1.0×, Low: 0.6×)";
